/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * Construct a type with a set of properties K of type T
 */
export interface RecordStringUnknown {
  [key: string]: unknown
}
